import styled from "styled-components";
import colors from "../../../assets/styles/colors";

export const BeneficiaryContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: ${colors.bgGray};
`;

export const BeneficiaryWrapper = styled.div``;

export const BeneficiaryContent = styled.div`
  width: 100%;
  max-width: 610px;
  padding-top: 20px;
  padding-bottom: 20px;
`;

export const BeneficiaryLineFormLabel = styled.div`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.textPrimary};
`;

export const BeneficiaryLineFormItem = styled.div`
  margin-top: 30px;
`;

export const BeneficiaryAddLine = styled.button`
  font-weight: bold;
  border: 0;
  outline: 0;
  margin-top: 20px;
  background-color: transparent;
  font-size: 14px;
  line-height: 17px;
  color: ${colors.bgSecondary};
  cursor: pointer;
`;

export const BeneficiaryLineFormHeaderItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const BeneficiaryLineFormDeleteItem = styled.span`
  cursor: pointer;
  color: ${colors.bgDanger};
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
`;
